import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { RoutersMenu, TabRouter } from '../models/components-general/router.model';
import { HomeMenus, MenuRuter } from '../models/home-model/home.model';
import { GeneralService } from './general.service';

@Injectable({
  providedIn: 'root',
})
export class RouteService {
  public URL_API = environment.apiURLNew;

  /**
   * Genera una función contadora que retorna el índice secuencial (0, 1, 2...)
   * cada vez que se invoca.
   */
  private createIndexCounter(): () => number {
    let index = 0;
    return () => index++;
  }

  // Tabs
  private payIdx = this.createIndexCounter();
  public paymentsRouter: TabRouter[] = [
    {
      descripcion: 'payments.tabs.operations',
      indexSelected: this.payIdx(),
      url: 'active-portfolio',
    },
    {
      descripcion: 'payments.tabs.entry',
      indexSelected: this.payIdx(),
      url: 'active-portfolio/payments',
    },
    {
      descripcion: 'payments.tabs.interfaz-stp',
      indexSelected: this.payIdx(),
      url: 'active-portfolio/interfaz-stp',
    },
    {
      descripcion: 'payments.tabs.inventory',
      indexSelected: this.payIdx(),
      url: 'active-portfolio/inventory',
    },
    {
      descripcion: 'menus.maintenance',
      indexSelected: this.payIdx(),
      url: 'active-portfolio/maintenance',
    },
    {
      descripcion: 'menus.leaseLine',
      indexSelected: this.payIdx(),
      url: 'active-portfolio/leaseLine',
    },
  ];

  private sysIdx = this.createIndexCounter();
  public systemsRouter: TabRouter[] = [
    {
      descripcion: 'catalogs.dealers.title',
      indexSelected: this.sysIdx(),
      url: 'catalogs/dealers',
    },
    { descripcion: 'users.title', indexSelected: this.sysIdx(), url: 'users' },
    {
      descripcion: 'catalogs.suppliers.title',
      indexSelected: this.sysIdx(),
      url: 'catalogs/suppliers',
    },
    {
      descripcion: 'Notificación del sistema',
      indexSelected: this.sysIdx(),
      url: 'catalogs/notifications',
    },
    {
      descripcion: 'users.userTypes.title',
      indexSelected: this.sysIdx(),
      url: 'catalogs/user-types',
    },
    {
      descripcion: 'catalogs.bureauUsers.title',
      indexSelected: this.sysIdx(),
      url: 'catalogs/bureau-users',
    },
  ];

  private quoteIdx = this.createIndexCounter();
  public quoteRouter: TabRouter[] = [
    { descripcion: 'catalogs.plans.title', indexSelected: this.quoteIdx(), url: 'catalogs/plans' },
    {
      descripcion: 'catalogs.brands.title',
      indexSelected: this.quoteIdx(),
      url: 'catalogs/brands',
    },
    {
      descripcion: 'catalogs.programs.title',
      indexSelected: this.quoteIdx(),
      url: '/catalogs/programs',
    },
    {
      descripcion: 'catalogs.insurances.title',
      indexSelected: this.quoteIdx(),
      url: 'catalogs/insurances',
    },
    {
      descripcion: 'catalogs.deadlines.title',
      indexSelected: this.quoteIdx(),
      url: 'catalogs/deadlines',
    },
    {
      descripcion: 'catalogs.tasksList.title',
      indexSelected: this.quoteIdx(),
      url: 'catalogs/tasks-list',
    },
    {
      descripcion: 'catalogs.additional.title',
      indexSelected: this.quoteIdx(),
      url: 'catalogs/additional',
    },
    {
      descripcion: 'catalogs.products.title',
      indexSelected: this.quoteIdx(),
      url: 'catalogs/products',
    },
    {
      descripcion: 'catalogs.personTypes.title',
      indexSelected: this.quoteIdx(),
      url: 'catalogs/person-types',
    },
  ];

  private analyticsIdx = this.createIndexCounter();
  public analyticsRouter: TabRouter[] = [
    { descripcion: 'Tableros', indexSelected: this.analyticsIdx(), url: 'boards' },
    {
      descripcion: 'Cartera Vencida',
      indexSelected: this.analyticsIdx(),
      url: 'expired-portfolio',
    },
    { descripcion: 'menus.generador', indexSelected: this.analyticsIdx(), url: 'reportes' },
  ];

  // Rutas Menu
  public configurationRouter: RoutersMenu[] = [
    {
      descripcion: 'Configuración de Flujo de trabajo',
      url: 'configuration/workflow',
    },
    {
      descripcion: 'Configuración por page',
      url: 'configuration/page',
    },
    { descripcion: 'Sistema', url: 'catalogs/dealers' },
    { descripcion: 'Cotizador', url: 'catalogs/plans' },
  ];

  public quotationHomeRouter: RoutersMenu[] = [
    { descripcion: 'menus.quotation', url: 'quotation' },
    { descripcion: 'menus.leaseLine', url: 'lease-line' },
  ];

  public workflowHomeRouter: RoutersMenu[] = [{ descripcion: 'menus.workflow', url: 'workflow' }];

  // Menu Carvers
  public menuCarvesrt: HomeMenus[] = [
    {
      icon: 'settings',
      description: 'menus.configuration',
      isTab: false,
      menu: this.configurationRouter.map((item) => ({
        description: item.descripcion,
        url: item.url ?? '',
      })),
    },
    {
      isTab: true,
      icon: ' request_quote',
      description: 'menus.quotation',
      menu: this.quotationHomeRouter.map((item) => ({
        description: item.descripcion,
        url: item.url ?? '',
      })),
    },
    {
      isTab: false,
      icon: 'work',
      description: 'menus.workflow',
      url: this.workflowHomeRouter[0]?.url,
      menu: [],
    },
    {
      isTab: true,
      icon: 'local_atm',
      description: 'menus.active-portfolio',
      menu: this.paymentsRouter.map((item) => ({
        description: item.descripcion,
        url: item.url ?? '',
      })),
    },
    {
      isTab: true,
      icon: 'analytics',
      description: 'menus.analytics',
      menu: this.analyticsRouter.map((item) => ({
        description: item.descripcion,
        url: item.url ?? '',
      })),
    },
  ];

  constructor(private generalService: GeneralService) {}

  public changeSelected(url: string, indexSelected: number): void {
    this.generalService.goToUrl([url], { indexSelected }, false);
  }
}
